module.exports = __webpack_public_path__ + "static/img/video-loading.bb7e3fec.gif";